import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImageMedia, VimeoMedia } from '@madeinlune/drupal-types';
import { MediaImageComponent } from '@nx-massaud/media/ui/image';

@Component({
  selector: 'msd-det-ui-cover',
  standalone: true,
  imports: [CommonModule, MediaImageComponent],
  template: `
    <ng-container *ngIf="media">
      <ng-container *ngIf="media.type === 'images'">
        <i2l-media-image
          [image]="$any(media)"
          [objectFit]="'cover'"
        ></i2l-media-image>
      </ng-container>
    </ng-container>
  `,
  styleUrls: ['./cover.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class CoverComponent {
  @Input() media: ImageMedia | VimeoMedia | undefined;
}
